import {
  Button,
  ComponentWithAs,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';
import FilterCategories from './FilterCategories';

type ChooseDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ChooseDrawer: ComponentWithAs<'section', ChooseDrawerProps> = forwardRef<ChooseDrawerProps, 'section'>(
  (props, ref) => {
    return (
      <Drawer placement='bottom' {...props}>
        <DrawerContent borderTopRadius={16} maxW='62em !important' mx='auto' ref={ref}>
          {
            // TODO: Add drag handle.
          }
          <Button mt={2} mr={2} mb={-4} ml='auto' size='sm' variant='white' onClick={props.onClose}>
            완료
          </Button>
          <DrawerHeader fontSize={['lg', 'xl']}>먹고 싶지 않은 음식이 있나요?</DrawerHeader>
          <DrawerBody>
            <FilterCategories />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  },
);

export default ChooseDrawer;
